<template>
  <div class="flex grow relative">
    <!-- Top -->
    <div class="fixed top-0 h-[72px] w-full flex items-center justify-start bg-white z-[1001] shadow-sm">
      <div class="flex flex-row flex-nowrap content-center items-center justify-between w-full">
        <slot
          name="top"
          data-test="top-slot"
        ></slot>
      </div>
    </div>

    <!-- Bottom -->
    <div class="fixed bottom-0 h-[72px] w-full flex items-center justify-start bg-white z-[1001] shadow-sm">
      <div class="flex flex-row flex-nowrap content-center items-center justify-between w-full mx-6">
        <slot
          name="bottom"
          data-test="bottom-slot"
        ></slot>
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="flex grow flex-col">
      <div class="w-full flex flex-row grow items-start justify-center px-4">
        <Card
          class="flex flex-col w-full max-w-3xl p-0 lg:px-6 overflow-auto mt-[92px] mb-[92px] relative"
          ref="mainContent"
          data-test="main-content"
        >
          <template #content>
            <slot
              name="main"
              data-test="main-slot"
            ></slot>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, nextTick, watchEffect } from 'vue';

const mainContent = ref(null);

// Props for animated transition of main content
const props = defineProps({
  slideOut: Boolean,
  slideIn: Boolean,
});

const transitionTime = 500;
const transitionRule = `transform cubic-bezier(0.4, 0, 0.2, 1) ${transitionTime}ms`;

watchEffect(() => {
  if (!mainContent.value || (!props.slideOut && !props.slideIn)) return;

  const $el = mainContent.value.$el;

  $el.style.transition = '';
  $el.style.transform = 'translateX(0)';

  $el.style.transition = transitionRule;

  const animate = (outRule, inRule) => {
    $el.style.transform = `translateX(calc(${outRule}))`;
    setTimeout(() => {
      $el.style.transition = '';
      $el.style.transform = `translateX(calc(${inRule}))`;
      setTimeout(() => {
        $el.style.transition = transitionRule;
        $el.style.transform = 'translateX(0)';
        setTimeout(() => {
          $el.style.transition = '';
          $el.style.transform = '';
        }, transitionTime);
      }, transitionTime / 10);
    }, transitionTime);
  };

  if (props.slideOut) {
    animate('-50vw - 50%', '50vw + 50%');
  } else if (props.slideIn) {
    animate('50vw + 50%', '-50vw - 50%');
  }
});
</script>
